import { Box, css, Skeleton, Stack, styled, Typography } from '@mui/material';
import { CircleNotch } from '@phosphor-icons/react';

const RotatingIcon = styled(CircleNotch)(
  () => css`
    animation: spin 1s linear infinite;

    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  `,
);

export function ResultStructureSkeleton() {
  return (
    <Box
      sx={{
        borderRadius: 1,
        backgroundColor: '#f5f5f5',
        padding: 2,
        marginBottom: 2,
      }}
    >
      <Stack
        alignItems="center"
        direction="row"
        gap={2}
        sx={{
          backgroundColor: 'white',
          padding: 2,
          borderRadius: 1,
        }}
      >
        <Box sx={{ flex: 1 }}>
          <Typography color="textSecondary" variant="h5">
            Lädt...
          </Typography>
          <Skeleton height={16} sx={{ mt: 1 }} variant="text" width={118} />
          <Skeleton height={24} sx={{ mt: 1 }} variant="text" width={160} />
        </Box>
        <RotatingIcon size={32} weight="fill" />
      </Stack>
    </Box>
  );
}
